import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const Frame = ({ children }) => (
  <div className="grid min-h-screen place-items-center bg-slate-50 px-4">
    <div className="rise w-full max-w-md rounded-2xl border border-slate-200 bg-white p-10 text-center shadow-sm">{children}</div>
  </div>
);

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const { refresh } = useAuth();
  const [state, setState] = useState("checking");

  useEffect(() => {
    const sid = params.get("session_id");
    let tries = 0;
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") {
          setState("paid");
          refresh();
          return;
        }
        if (["expired", "failed"].includes(data.payment_status)) {
          setState("failed");
          return;
        }
      } catch (e) {
        setState("failed");
        return;
      }
      tries += 1;
      if (tries < 15) timer = setTimeout(poll, 2000);
      else setState("timeout");
    };
    poll();
    return () => clearTimeout(timer);
  }, [params, refresh]);

  return (
    <Frame>
      {state === "checking" && <><Loader2 className="mx-auto h-10 w-10 animate-spin text-indigo-600" /><p className="mt-4 font-display text-xl font-bold" data-testid="payment-status">Confirming your payment…</p></>}
      {state === "paid" && <><CheckCircle2 className="mx-auto h-12 w-12 text-emerald-600" /><p className="mt-4 font-display text-2xl font-bold" data-testid="payment-status">Subscription active</p><p className="mt-2 text-sm text-slate-500">Thanks — your plan is live.</p></>}
      {(state === "failed" || state === "timeout") && <><XCircle className="mx-auto h-12 w-12 text-rose-600" /><p className="mt-4 font-display text-2xl font-bold" data-testid="payment-status">{state === "failed" ? "Payment not completed" : "Still processing"}</p><p className="mt-2 text-sm text-slate-500">Check Billing in a minute.</p></>}
      <Link to="/app/billing" className="mt-8 inline-block rounded-full bg-indigo-600 px-6 py-2.5 text-sm font-semibold text-white hover:bg-indigo-700" data-testid="payment-continue-btn">Go to dashboard</Link>
    </Frame>
  );
}

export function PaymentCancel() {
  return (
    <Frame>
      <XCircle className="mx-auto h-12 w-12 text-slate-400" />
      <p className="mt-4 font-display text-2xl font-bold" data-testid="payment-status">Checkout cancelled</p>
      <p className="mt-2 text-sm text-slate-500">No payment was taken. You can pick a plan any time from Billing.</p>
      <Link to="/app/billing" className="mt-8 inline-block rounded-full bg-indigo-600 px-6 py-2.5 text-sm font-semibold text-white" data-testid="payment-back-btn">Back to billing</Link>
    </Frame>
  );
}
